import React from 'react'
import { Row, Container } from 'react-bootstrap';
import './casestudybody38.css';

import clientimg from '../images/case-study-client38.webp'
import outcome from '../images/outcome38.webp'

import sm1 from '../images/cs38so1u.webp'
import sm2 from '../images/cs38so2u.webp'
import sm3 from '../images/cs38so3u.webp'


const Casestudybody38 = () => {

    return (
        <>
        <section className='casestudybody38-section'  >
          <Container>

            <Row className='w-100 py-md-5 py-4 clintrow'>
                <div className='col-md-4 relative order-1'>
                  <div className='left-box'>
                    <div className='content-box'>
                      <h2>About</h2>
                      {/* <div className="h1"><span className='h1 animate-underline' style={{ paddingBottom: "40px" }}>The Client</span></div> */}
                      <div className="h1">The Client</div>
                      <p className='anima '><span className='only-anima-underline' > **** </span></p>
                      <p>A US-based mid-market private equity platform with an investment thesis focused on growth equity opportunities across specialized market segments </p>
                    </div>
                  </div>
                           
                </div>
                <div className='col-md-8 right-box'>
                    <img src={clientimg} alt="" />
                </div>
            </Row>
       
            <Row className='mt-md-5'>
              <div className='col-md-12'>
                <div className='content-box'>
                  <h2>Situation</h2>
                  {/* <div className="h1"><span className='h1 animate-underline' style={{ paddingBottom: "40px" }}>The Client</span></div> */}
                  <div className="h1">Overview</div>
                  <p className='anima '><span className='only-anima-underline' > **** </span></p>
                  <p>Client required a quarterly reporting framework to effectively communicate investment performance and progress to shareholders, aiming to enhance transparency, engagement, and trust among investors through regular, data-driven updates</p>
                </div>               
              </div>
            </Row>
          </Container>
        </section>
    
        <section className='casestudybody38-section bg-gredient-dark'>
          <Container>
            <Row>
              <div className='col-md-12'>
                  <div className='content-box'>
                    <h2>Approach &</h2>
                    {/* <div className="h1"><span className='h1 animate-underline' style={{ paddingBottom: "40px" }}>The Client</span></div> */}
                    <div className="h1">Methodology</div>
                    <p className='anima '><span className='only-anima-underline' > **** </span></p>
                    {/* <p>The next step was to put together and implement a step-by-step process for conducting the valuation:</p> */}
                    
                    <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>
                        <div className='text'>
                          <h4>Onboarding Workshop: </h4>
                          <p>Conducted an onboarding workshop to <span style={{color:"#03A393"}}>understand client requirements, define project scope, and establish clear deliverables</span>, ensuring alignment and mutual understanding</p>
                        </div>
                      </div>
    
                    <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>
                        <div className='text'>
                          <h4>Data Aggregation: </h4>
                          <p>Gathered comprehensive <span style={{color:"#03A393"}}>financial and non-financial performance metrics</span> from the client to consolidate multidimensional performance metrics</p>
                        </div>
                      </div>
    
                      <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>
                        <div className='text'>
                          <h4>Industry Overview:</h4>
                          <p>Collected <span style={{color:"#03A393"}}>market insights across portfolio & target companies</span>, including; industry trends, outlook and competitive landscape</p>
                        </div>
                      </div>
    
                      <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>

                        <div className='text'>
                          <h4>Fund and Portfolio Analysis:</h4>
                          <p>Performed an <span style={{color:"#03A393"}}>in-depth analysis of the fund's performance</span>, employing both qualitative and quantitative methodologies, including; trend analysis (QoQ comparison to identify performance patterns), variance analysis (highlighted deviations from established trends)</p>
                        </div>
                      </div>

                      <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>

                        <div className='text'>
                          <h4>Portfolio Company Updates and NAV Calculation: </h4>
                          <p>Calculated & reported the <span style={{color:"#03A393"}}>quarterly NAV of the portfolio</span> and highlighted important updates across the portfolio company</p>
                        </div>
                      </div>                 

                      <div className='list-text last-child my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>

                        <div className='text'>
                          <h4>Reporting:</h4>
                          <p>Developed comprehensive reporting frameworks, leveraging sophisticated <span style={{color:"#03A393"}}>data analysis to summarize the quarterly fund performance</span> based on the detailed analysis conducted, enabling informed decision-making and transparency</p>
                        </div>
                      </div> 

                                        
                      <h3 className='mt-5'>Sample Output</h3>
                      <div className='sample-output mt-3'>
                        <img src={sm1} alt=''/>
                        <img src={sm2} alt=''/>
                        <img src={sm3} alt=''/>

                      </div>
                  </div>
                  
                </div>
            </Row>
          </Container>
        </section>

    
        <section className='casestudybody38-section outcome'  >
          <Container>
            <Row className='w-100 pb-5 clintrow '>
                <div className='col-md-4 relative order-1'>
                  <div className='left-box'>
                    <div className='content-box'>
                      <div className="h1">Outcome</div>
                      <p className='anima '><span className='only-anima-underline' > **** </span></p>
                      <p>This resulted in enhanced shareholder engagement and informed decision-making, enabling the client to provide transparent and timely reporting, data-driven insights, and fact-based dialogue with stakeholders</p>  
                    </div>
                  </div>
                           
                </div>
                <div className='col-md-8 right-box'>
                    <img src={outcome} alt="" />
                </div>
            </Row>
       
          </Container>
        </section>
    
        </>  
      )
    }

export default Casestudybody38
